import React from 'react';
const ANDROID_DEEPLINK_URL = 'https/www.udemy.com/';
export const ANDROID_PACKAGE_NAME = 'com.udemy.android';
const queryInput = 'search_term_string';
export const SitelinkSearchBoxScript = _ref => {
  let {
    brandUrl,
    searchHandlerUri,
    androidDeeplinkUrl = ANDROID_DEEPLINK_URL,
    androidPackageName = ANDROID_PACKAGE_NAME,
    headWrapper
  } = _ref;
  const searchHandlerUrl = searchHandlerUri.concat(`?q={${queryInput}}`);
  const androidSearchUrl = `android-app://${androidPackageName}/${androidDeeplinkUrl}deeplink?query={${queryInput}}`;
  const searchActionWeb = {
    '@type': 'SearchAction',
    target: searchHandlerUrl,
    'query-input': `required name=${queryInput}`
  };
  const searchActionAndroid = {
    '@type': 'SearchAction',
    target: androidSearchUrl,
    'query-input': `required name=${queryInput}`
  };
  const searchBox = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: brandUrl,
    potentialAction: [searchActionWeb, searchActionAndroid]
  };
  const Head = headWrapper !== null && headWrapper !== void 0 ? headWrapper : React.Fragment;
  return /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
    // We use dangerouslySetInnerHTML to keep the correct format ("@context":"https://schema.org",...) instead of {&quot;@context&quot;:&quot;https://schema.org&quot;,...
    ,
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(searchBox)
    }
  }));
};
//# sourceMappingURL=sitelink-search-box-script.react-component.js.map